"use client";

import { ProductType } from "@/types/Products";
import {
  GroupedProduct,
  groupProductsByCategory,
} from "@/utils/groupProductsByCategory";
import SliderCards from "../SliderCards";

type MediaCardsSectionsProps = {
  products: ProductType[];
};

const MediaCardsSections = ({ products }: MediaCardsSectionsProps) => {
  const groupedByCategory = groupProductsByCategory(products || []);
  return (
    <>
      {groupedByCategory?.map((item) => (
        <div key={item.category.id} id={`category_${item.category.id}`}>
          <SliderCards
            section={{
              content: {
                title: item.category.title || "",
                cards: item.products,
                perSlides: 5,
                categoryId: item.category.id,
              },
            }}
          />
        </div>
      ))}
    </>
  );
};

export default MediaCardsSections;
